import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @mui/material components
import Box from "@mui/material/Box";

// sx styles (migrated from JSS cardBodyStyle.js — Faz 7)
const cardBodySx = {
  padding: "0.9375rem 1.875rem",
  flex: "1 1 auto"
};

export default function CardBody(props) {
  const { className, children, ...rest } = props;
  return (
    <Box className={className} sx={cardBodySx} {...rest}>
      {children}
    </Box>
  );
}

CardBody.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};
